"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var getSpecification_1 = __importDefault(require("../../utils/getSpecification"));
var constants_1 = require("../../utils/constants");
var Title_1 = __importDefault(require("../Title"));
function CarComment(props) {
    var specification = props.specification;
    var comment = getSpecification_1.default(specification, constants_1.CAR_SPEC_OTHER, 'dealer_comment');
    return ((comment && (react_1.default.createElement("div", { className: "azgazui__comment" },
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement(Title_1.default, { level: "h2" }, "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439 \u0434\u0438\u043B\u0435\u0440\u0430"),
            react_1.default.createElement("p", null, comment))))) ||
        null);
}
exports.default = CarComment;
CarComment.displayName = 'CarComment';
CarComment.propTypes = {
    specification: prop_types_1.default.arrayOf(prop_types_1.default.object),
};
CarComment.defaultProps = {
    specification: undefined,
};
